export const colors = {
  text: "#111111",
  primary: "#040663",
  secondary: "#D6C6FF",
  tertiary: "#6247AA",
  accent: "#EE6823",
};
